import { ElementRef } from '@angular/core';
import { AUTO_REFRESH_DAILY, AUTO_REFRESH_MONTHLY, AUTO_REFRESH_NEVER, AUTO_REFRESH_WEEKLY, } from 'AccountsApp/ts/apps/account-integrations-app/components/account-integrations-page/constants';
import { LEGACY_ONLY_DATA } from 'AccountsApp/ts/constants/user-preferences.constants';
import { ADDEPAR_INTEGRATION_FEATURE, ADVYZON_INTEGRATION_FEATURE, AUTO_REFRESH_IMPORTED_CUSTOM_SECURITIES_FEATURE, AUTO_REFRESH_IMPORTED_PORTFOLIOS_FEATURE, AVISO_INTEGRATION_FEATURE, BLACK_DIAMOND_INTEGRATION_FEATURE, BROADRIDGE_INTEGRATION_FEATURE, EMONEY_INTEGRATION_FEATURE, FIDELITY_INTEGRATION_FEATURE, HARTFORD_INTEGRATION_FEATURE, LPL_INTEGRATION_FEATURE, NORTHWESTERN_MUTUAL_INTEGRATION_FEATURE, ORION_INTEGRATION_FEATURE, PERSHING_INTEGRATION_FEATURE, RAYMOND_JAMES_INTEGRATION_FEATURE, REDTAIL_INTEGRATION_FEATURE, SCHWAB_INTEGRATION_FEATURE, VRGL_INTEGRATION_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import * as i0 from "@angular/core";
import * as i1 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i2 from "AccountsApp/ts/services/accounts.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i5 from "./integrations-items/addepar-integration-list-item/addepar-integration-list-item.component";
import * as i6 from "./integrations-items/black-diamond-integration-list-item/black-diamond-integration-list-item.component";
import * as i7 from "./integrations-items/emoney-integration-list-item/emoney-integration-list-item.component";
import * as i8 from "./integrations-items/fidelity-integration-list-item/fidelity-integration-list-item.component";
import * as i9 from "AccountsApp/ts/apps/account-integrations-app/components/account-integrations-page/integrations-items/hartford-integration-list-item/hartford-integration-list-item.component";
import * as i10 from "./integrations-items/orion-integration-list-item/orion-integration-list-item.component";
import * as i11 from "./integrations-items/redtail-integration-list-item/redtail-integration-list-item.component";
import * as i12 from "./integrations-items/schwab-integration-list-item/schwab-integration-list-item.component";
import * as i13 from "./integrations-items/pershing-integration-list-item/pershing-integration-list-item.component";
import * as i14 from "./integrations-items/vrgl-integration-list-item/vrgl-integration-list-item.component";
import * as i15 from "./integrations-items/broadridge-integration-list-item/broadridge-integration-list-item.component";
import * as i16 from "./integrations-items/raymond-james-integration-list-item/raymond-james-integration-list-item.component";
import * as i17 from "./integrations-items/northwestern-mutual-integration-list-item/northwestern-mutual-integration-list-item.component";
import * as i18 from "AccountsApp/ts/apps/account-integrations-app/components/account-integrations-page/integrations-items/aviso-integration-list-item/aviso-integration-list-item.component";
import * as i19 from "AccountsApp/ts/apps/account-integrations-app/components/account-integrations-page/integrations-items/lpl-integration-list-item/lpl-integration-list-item.component";
import * as i20 from "AccountsApp/ts/apps/account-integrations-app/components/account-integrations-page/integrations-items/advyzon-integration-list-item/advyzon-integration-list-item.component";
const _c0 = () => ({ button: "btn btn-secondary dropdown-toggle", dropdownContainer: "mt-1" });
function AccountIntegrationsPageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 10);
    i0.ɵɵtext(2, "Custom security Refresh");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-single-select-dropdown", 11);
    i0.ɵɵlistener("changeHandler", function AccountIntegrationsPageComponent_div_4_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setAutoRefreshSetting($event, ctx_r1.AUTO_REFRESH_CUSTOM_SECURITIES_PREFERENCE)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("selectedValue", ctx_r1.selectedCustomSecurityRefresh)("config", ctx_r1.autoRefreshDropdownConfig)("customCssClasses", i0.ɵɵpureFunction0(4, _c0))("placeholderText", "NOT SET");
} }
function AccountIntegrationsPageComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "label", 10);
    i0.ɵɵtext(2, "Portfolio Refresh");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-single-select-dropdown", 12);
    i0.ɵɵlistener("changeHandler", function AccountIntegrationsPageComponent_div_5_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setAutoRefreshSetting($event, ctx_r1.AUTO_REFRESH_MODEL_PORTFOLIOS_PREFERENCE)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("appendToBody", true)("selectedValue", ctx_r1.selectedPortfolioRefresh)("config", ctx_r1.autoRefreshDropdownConfig)("placeholderText", "NOT SET")("customCssClasses", i0.ɵɵpureFunction0(5, _c0));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 30);
} if (rf & 2) {
    const key_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientId", ctx_r1.getIntegrationProp(key_r4, "ClientId"))("authUrl", ctx_r1.getIntegrationProp(key_r4, "AuthUrl"))("redirectUri", ctx_r1.getIntegrationProp(key_r4, "RedirectUri"));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 31);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 32);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 33);
} if (rf & 2) {
    const key_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientId", ctx_r1.getIntegrationProp(key_r4, "ClientId"))("authUrl", ctx_r1.getIntegrationProp(key_r4, "AuthUrl"))("redirectUri", ctx_r1.getIntegrationProp(key_r4, "RedirectUri"));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 34);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 35);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 36);
} if (rf & 2) {
    const key_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientId", ctx_r1.getIntegrationProp(key_r4, "ClientId"))("authUrl", ctx_r1.getIntegrationProp(key_r4, "AuthUrl"))("redirectUri", ctx_r1.getIntegrationProp(key_r4, "RedirectUri"));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 37);
} if (rf & 2) {
    const key_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientId", ctx_r1.getIntegrationProp(key_r4, "ClientId"))("authUrl", ctx_r1.getIntegrationProp(key_r4, "AuthUrl"))("redirectUri", ctx_r1.getIntegrationProp(key_r4, "RedirectUri"));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 38);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 39);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 40);
} if (rf & 2) {
    const key_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientId", ctx_r1.getIntegrationProp(key_r4, "ClientId"))("authUrl", ctx_r1.getIntegrationProp(key_r4, "AuthUrl"))("redirectUri", ctx_r1.getIntegrationProp(key_r4, "RedirectUri"));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 41);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 42);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 43);
} }
function AccountIntegrationsPageComponent_tbody_17_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 44);
} if (rf & 2) {
    const key_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("clientId", ctx_r1.getIntegrationProp(key_r4, "ClientId"))("oauthUrl", ctx_r1.getIntegrationProp(key_r4, "OAuthUrl"))("redirectUri", ctx_r1.getIntegrationProp(key_r4, "RedirectUri"));
} }
function AccountIntegrationsPageComponent_tbody_17_tr_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 45);
} }
function AccountIntegrationsPageComponent_tbody_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tbody", 13);
    i0.ɵɵtemplate(1, AccountIntegrationsPageComponent_tbody_17_tr_1_Template, 1, 3, "tr", 14)(2, AccountIntegrationsPageComponent_tbody_17_tr_2_Template, 1, 0, "tr", 15)(3, AccountIntegrationsPageComponent_tbody_17_tr_3_Template, 1, 0, "tr", 16)(4, AccountIntegrationsPageComponent_tbody_17_tr_4_Template, 1, 3, "tr", 17)(5, AccountIntegrationsPageComponent_tbody_17_tr_5_Template, 1, 0, "tr", 18)(6, AccountIntegrationsPageComponent_tbody_17_tr_6_Template, 1, 0, "tr", 19)(7, AccountIntegrationsPageComponent_tbody_17_tr_7_Template, 1, 3, "tr", 20)(8, AccountIntegrationsPageComponent_tbody_17_tr_8_Template, 1, 3, "tr", 21)(9, AccountIntegrationsPageComponent_tbody_17_tr_9_Template, 1, 0, "tr", 22)(10, AccountIntegrationsPageComponent_tbody_17_tr_10_Template, 1, 0, "tr", 23)(11, AccountIntegrationsPageComponent_tbody_17_tr_11_Template, 1, 3, "tr", 24)(12, AccountIntegrationsPageComponent_tbody_17_tr_12_Template, 1, 0, "tr", 25)(13, AccountIntegrationsPageComponent_tbody_17_tr_13_Template, 1, 0, "tr", 26)(14, AccountIntegrationsPageComponent_tbody_17_tr_14_Template, 1, 0, "tr", 27)(15, AccountIntegrationsPageComponent_tbody_17_tr_15_Template, 1, 3, "tr", 28)(16, AccountIntegrationsPageComponent_tbody_17_tr_16_Template, 1, 0, "tr", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngSwitch", key_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "addepar");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "advyzon");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "aviso");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "blackDiamond");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "broadridge");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "fidelity");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "emoney");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "hartford");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "lpl");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "northwesternMutual");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "orion");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "pershing");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "raymondJames");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "redtail");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "schwab");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "vrgl");
} }
export class AccountIntegrationsPageComponent {
    // Expose a safe dynamic accessor for integration-specific props to templates
    getIntegrationProp(key, prop) {
        const propName = `${key}${prop}`;
        const value = this[propName];
        return typeof value === 'string' ? value : '';
    }
    constructor(eltRef, featureService, accountsService) {
        this.eltRef = eltRef;
        this.featureService = featureService;
        this.accountsService = accountsService;
        this.USER = window.USER;
        this.autoRefreshDropdownConfig = {
            title: {
                label: '',
            },
            list: [
                {
                    label: 'DAILY',
                    value: AUTO_REFRESH_DAILY,
                },
                {
                    label: 'WEEKLY',
                    value: AUTO_REFRESH_WEEKLY,
                },
                {
                    label: 'MONTHLY',
                    value: AUTO_REFRESH_MONTHLY,
                },
                {
                    label: 'NEVER',
                    value: AUTO_REFRESH_NEVER,
                },
            ],
        };
        this.selectedPortfolioRefresh = null;
        this.selectedCustomSecurityRefresh = null;
        this.enabledIntegrationsSorted = [];
        // Constants
        this.AUTO_REFRESH_CUSTOM_SECURITIES_PREFERENCE = 'auto_refresh_imported_custom_securities_frequency';
        this.AUTO_REFRESH_MODEL_PORTFOLIOS_PREFERENCE = 'auto_refresh_imported_model_portfolios_frequency';
        this.INTEGRATIONS = {
            addepar: { displayName: 'Addepar', features_needed: [ADDEPAR_INTEGRATION_FEATURE] },
            blackDiamond: { displayName: 'Black Diamond', features_needed: [BLACK_DIAMOND_INTEGRATION_FEATURE] },
            broadridge: { displayName: 'Broadridge', features_needed: [BROADRIDGE_INTEGRATION_FEATURE] },
            emoney: { displayName: 'eMoney', features_needed: [EMONEY_INTEGRATION_FEATURE] },
            fidelity: { displayName: 'Fidelity', features_needed: [FIDELITY_INTEGRATION_FEATURE] },
            hartford: { displayName: 'Hartford Funds', features_needed: [HARTFORD_INTEGRATION_FEATURE] },
            orion: { displayName: 'Orion', features_needed: [ORION_INTEGRATION_FEATURE] },
            pershing: { displayName: 'Pershing', features_needed: [PERSHING_INTEGRATION_FEATURE] },
            raymondJames: { displayName: 'Raymond James', features_needed: [RAYMOND_JAMES_INTEGRATION_FEATURE] },
            redtail: { displayName: 'Redtail', features_needed: [REDTAIL_INTEGRATION_FEATURE] },
            schwab: { displayName: 'Schwab', features_needed: [SCHWAB_INTEGRATION_FEATURE] },
            vrgl: { displayName: 'VRGL', features_needed: [VRGL_INTEGRATION_FEATURE] },
            northwesternMutual: {
                displayName: 'Northwestern Mutual',
                features_needed: [NORTHWESTERN_MUTUAL_INTEGRATION_FEATURE],
            },
            aviso: { displayName: 'AVISO', features_needed: [AVISO_INTEGRATION_FEATURE] },
            lpl: { displayName: 'LPL', features_needed: [LPL_INTEGRATION_FEATURE] },
            advyzon: { displayName: 'Advyzon', features_needed: [ADVYZON_INTEGRATION_FEATURE] },
        };
        this.selectedDataMenuOption = LEGACY_ONLY_DATA;
        this.orionClientId = this.eltRef.nativeElement.getAttribute('orionClientId');
        this.orionAuthUrl = this.eltRef.nativeElement.getAttribute('orionAuthUrl');
        this.orionRedirectUri = this.eltRef.nativeElement.getAttribute('orionRedirectUri');
        this.addeparClientId = this.eltRef.nativeElement.getAttribute('addeparClientId');
        this.addeparAuthUrl = this.eltRef.nativeElement.getAttribute('addeparAuthUrl');
        this.addeparRedirectUri = this.eltRef.nativeElement.getAttribute('addeparRedirectUri');
        this.blackDiamondClientId = this.eltRef.nativeElement.getAttribute('blackDiamondClientId');
        this.blackDiamondAuthUrl = this.eltRef.nativeElement.getAttribute('blackDiamondAuthUrl');
        this.blackDiamondRedirectUri = this.eltRef.nativeElement.getAttribute('blackDiamondRedirectUri');
        this.emoneyClientId = this.eltRef.nativeElement.getAttribute('emoneyClientId');
        this.emoneyAuthUrl = this.eltRef.nativeElement.getAttribute('emoneyAuthUrl');
        this.emoneyRedirectUri = this.eltRef.nativeElement.getAttribute('emoneyRedirectUri');
        this.hartfordAuthUrl = this.eltRef.nativeElement.getAttribute('hartfordAuthUrl');
        this.hartfordClientId = this.eltRef.nativeElement.getAttribute('hartfordClientId');
        this.hartfordRedirectUri = this.eltRef.nativeElement.getAttribute('hartfordRedirectUri');
        this.schwabClientId = this.eltRef.nativeElement.getAttribute('schwabClientId');
        this.schwabOAuthUrl = this.eltRef.nativeElement.getAttribute('schwabOAuthUrl');
        this.schwabRedirectUri = this.eltRef.nativeElement.getAttribute('schwabRedirectUri');
        this.selectedCustomSecurityRefresh = this.eltRef.nativeElement.getAttribute('autoRefreshCustomSecuritiesFrequency');
        this.selectedPortfolioRefresh = this.eltRef.nativeElement.getAttribute('autoRefreshModelPortfoliosFrequency');
        this.enabledIntegrationsSorted = Object.keys(this.INTEGRATIONS)
            .filter((key) => this.isIntegrationEnabled(key))
            .sort((a, b) => this.INTEGRATIONS[a].displayName.localeCompare(this.INTEGRATIONS[b].displayName));
    }
    isIntegrationEnabled(key) {
        if (!(key in this.INTEGRATIONS)) {
            return false;
        }
        return this.featureService.userCanAccess(this.INTEGRATIONS[key]);
    }
    setAutoRefreshSetting(newOption, preference) {
        const putParams = {
            [preference]: newOption,
        };
        this.accountsService.putUserPreferences(putParams).subscribe(() => { });
    }
    get showCustomSecurityRefresh() {
        return this.featureService.userHasFeatures([AUTO_REFRESH_IMPORTED_CUSTOM_SECURITIES_FEATURE]);
    }
    get showModelPortfolioRefresh() {
        return this.featureService.userHasFeatures([AUTO_REFRESH_IMPORTED_PORTFOLIOS_FEATURE]);
    }
}
AccountIntegrationsPageComponent.ɵfac = function AccountIntegrationsPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AccountIntegrationsPageComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.FeatureService), i0.ɵɵdirectiveInject(i2.AccountsService)); };
AccountIntegrationsPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AccountIntegrationsPageComponent, selectors: [["ycn-account-integrations-page"]], standalone: false, decls: 18, vars: 3, consts: [[1, "topics-section"], [1, "topics-section-header", "mb-0"], [1, "row", "align-items-end", "justify-content-end", "pb-1"], ["class", "col-auto", 4, "ngIf"], [1, "table", "text-default", "mb-2"], [1, "col-4"], [1, "col-2"], [1, "text-right"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "col-auto"], [1, "form-label", "form-label-thin", "d-block"], [3, "changeHandler", "selectedValue", "config", "customCssClasses", "placeholderText"], [3, "changeHandler", "appendToBody", "selectedValue", "config", "placeholderText", "customCssClasses"], [3, "ngSwitch"], ["ycn-addepar-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri", 4, "ngSwitchCase"], ["ycn-advyzon-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-aviso-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-black-diamond-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri", 4, "ngSwitchCase"], ["ycn-broadridge-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-fidelity-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-emoney-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri", 4, "ngSwitchCase"], ["ycn-hartford-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri", 4, "ngSwitchCase"], ["ycn-lpl-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-northwestern-mutual-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-orion-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri", 4, "ngSwitchCase"], ["ycn-pershing-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-raymond-james-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-redtail-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-schwab-integration-list-item", "", 3, "clientId", "oauthUrl", "redirectUri", 4, "ngSwitchCase"], ["ycn-vrgl-integration-list-item", "", 4, "ngSwitchCase"], ["ycn-addepar-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri"], ["ycn-advyzon-integration-list-item", ""], ["ycn-aviso-integration-list-item", ""], ["ycn-black-diamond-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri"], ["ycn-broadridge-integration-list-item", ""], ["ycn-fidelity-integration-list-item", ""], ["ycn-emoney-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri"], ["ycn-hartford-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri"], ["ycn-lpl-integration-list-item", ""], ["ycn-northwestern-mutual-integration-list-item", ""], ["ycn-orion-integration-list-item", "", 3, "clientId", "authUrl", "redirectUri"], ["ycn-pershing-integration-list-item", ""], ["ycn-raymond-james-integration-list-item", ""], ["ycn-redtail-integration-list-item", ""], ["ycn-schwab-integration-list-item", "", 3, "clientId", "oauthUrl", "redirectUri"], ["ycn-vrgl-integration-list-item", ""]], template: function AccountIntegrationsPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵtext(2, "Integrations");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 2);
        i0.ɵɵtemplate(4, AccountIntegrationsPageComponent_div_4_Template, 4, 5, "div", 3)(5, AccountIntegrationsPageComponent_div_5_Template, 4, 6, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "table", 4)(7, "thead")(8, "tr")(9, "th");
        i0.ɵɵtext(10, "Partner Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "th", 5);
        i0.ɵɵtext(12, "Integration");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "th", 6);
        i0.ɵɵtext(14, "Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "th", 7);
        i0.ɵɵtext(16, "Activate");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(17, AccountIntegrationsPageComponent_tbody_17_Template, 17, 17, "tbody", 8);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showCustomSecurityRefresh);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showModelPortfolioRefresh);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngForOf", ctx.enabledIntegrationsSorted);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i4.SingleSelectDropdownComponent, i5.AddeparIntegrationListItemComponent, i6.BlackDiamondIntegrationListItemComponent, i7.EMoneyIntegrationListItemComponent, i8.FidelityIntegrationListItemComponent, i9.HartfordIntegrationListItemComponent, i10.OrionIntegrationListItemComponent, i11.RedtailIntegrationListItemComponent, i12.SchwabIntegrationListItemComponent, i13.PershingIntegrationListItemComponent, i14.VRGLIntegrationListItemComponent, i15.BroadridgeIntegrationListItemComponent, i16.RaymondJamesIntegrationListItemComponent, i17.NorthwesternMutualIntegrationListItemComponent, i18.AvisoIntegrationListItemComponent, i19.LPLIntegrationListItemComponent, i20.AdvyzonIntegrationListItemComponent], encapsulation: 2 });
